import { ApiService } from "Services/ApiService";
import {
  SocialMediaLink,
  GetAllSocialMediaLinksArgs,
  GetSocialMediaLinkByAccountTypeArgs,
  CreateSocialMediaLinkDTO,
  UpdateSocialMediaLinkDTO,
  DeleteSocialMediaLinkArgs,
} from "../../Types/Admin/SocialMediaLinks";
import { ResultsDTO } from "Types/ResultsDTO";

export const SocialMediaApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllSocialMediaLinks: builder.query<ResultsDTO<SocialMediaLink[]>, GetAllSocialMediaLinksArgs>({
      query: ({ plant }) => ({
        url: "/socialMediaLinks",
        method: "GET",
        params: { plant },
      }),
      providesTags: ["SocialMedia"],
    }),

    getSocialMediaLinkByAccountType: builder.query<ResultsDTO<SocialMediaLink>, GetSocialMediaLinkByAccountTypeArgs>({
      query: ({ plant, accountType }) => ({
        url: "/socialMediaLinks/get",
        method: "GET",
        params: { plant, accountType },
      }),
      providesTags: ["SocialMedia"],
    }),

    createSocialMediaLink: builder.mutation<ResultsDTO, CreateSocialMediaLinkDTO>({
      query: (data) => ({
        url: "/socialMediaLinks/save",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["SocialMedia"],
    }),

    updateSocialMediaLink: builder.mutation<ResultsDTO, UpdateSocialMediaLinkDTO>({
      query: (data) => ({
        url: "/socialMediaLinks/update",
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["SocialMedia"],
    }),

    deleteSocialMediaLink: builder.mutation<ResultsDTO, DeleteSocialMediaLinkArgs>({
      query: ({ id, plant }) => ({
        url: "/socialMediaLinks/delete",
        method: "DELETE",
        params: { id, plant },
      }),
      invalidatesTags: ["SocialMedia"],
    }),
  }),
});

export const {
  useGetAllSocialMediaLinksQuery,
  useLazyGetAllSocialMediaLinksQuery,
  useGetSocialMediaLinkByAccountTypeQuery,
  useLazyGetSocialMediaLinkByAccountTypeQuery,
  useCreateSocialMediaLinkMutation,
  useUpdateSocialMediaLinkMutation,
  useDeleteSocialMediaLinkMutation,
} = SocialMediaApiSlice;
